var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotaldepositsyeargrowth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "finance and payment/outline/money bag_coin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9999 18H13.9999M19.9999 18C21.1044 18 21.9999 18.8954 21.9999 20C21.9999 21.1046 21.1044 22 19.9999 22H13.9999C12.8953 22 11.9999 21.1046 11.9999 20C11.9999 18.8954 12.8953 18 13.9999 18M19.9999 18C21.1044 18 21.9999 17.1046 21.9999 16C21.9999 14.8954 21.1044 14 19.9999 14H19.3332M13.9999 18C12.8953 18 11.9999 17.1046 11.9999 16C11.9999 14.8954 12.8953 14 13.9999 14H19.3332M13.6753 22H10.3244C6.22908 22 3.33726 17.9878 4.63232 14.1026L5.63233 11.1026C6.44901 8.65258 8.74184 7 11.3244 7H12.6753C15.2579 7 17.5507 8.65258 18.3674 11.1026L19.3332 14",
    stroke: "#3686F0",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 855",
    d: "M14.0859 7L9.91411 7L8.51303 5.39296C7.13959 3.81763 8.74185 1.46298 10.7471 2.10985L11.6748 2.40914C11.8861 2.47728 12.1139 2.47728 12.3252 2.40914L13.2529 2.10985C15.2582 1.46298 16.8604 3.81763 15.487 5.39296L14.0859 7Z",
    stroke: "#3686F0",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotaldepositsyeargrowth);
export default __webpack_public_path__ + "static/media/totaldepositsyeargrowth.873ae607fe2c4bb4760631b26906bff1.svg";
export { ForwardRef as ReactComponent };